module.exports = __webpack_public_path__ + "static/quartier_F-41c09f4cc434c13631243a846b8e00d7.png";